import React from "react";

interface PageTitleProps {
  title: string;
}

const PageTitle: React.FC<PageTitleProps> = (props) => {
  const { title } = props;
  return <h1 className="pagetitle">{title}</h1>;
};

export default PageTitle;
